// extracted by mini-css-extract-plugin
module.exports = {"statisticsContainer":"az_EOb"};